import React, { Component } from "react";
import { Link } from "react-router-dom";

class CheckoutError extends Component {
  render() {
    const {  error, order, event, language } = this.props;
    let hrefLink = '#';
    return (
      <form key={4} className="w-full md:w-2/3">
        <h2 className="mb-6">We're Sorry</h2>
        {(error.code > 0 || error.message !== "") && (
          <div className="errorMessage">

            {error.code !== 2 && (
              <p className="leading-normal mb-2">{error.message}</p>
            )}

            {error.code === 2 && (
              <h2 className="mb-6">{language.en.locationError_title}</h2>
            )}
            {error.code === 2 && (
              <p className="leading-normal mb-2 p1">
                {language.en.locationError_message}
              </p>
            )}
            {error.code === 2 && (
              <p className="leading-normal mb-2 p2">
                {error.message}
              </p>
            )}
            {error.code === 2 && (
              <p className="leading-normal">
                <Link to={language.en.locationError_link}>Click here</Link> to learn how to enable your Device Location Services.<br />
                <br />
              </p>
            )}

            {error.action === "default" && (
              <p className="leading-normal">
                <Link to="/">Return to home page</Link>
              </p>
            )}

            {error.action === "reload" && (
              <p className="leading-normal">
                <a
                  href={hrefLink}
                  onClick={e => {
                    e.preventDefault();
                    window.location.reload();
                  }}
                >
                  Reload this page
                </a>
              </p>
            )}
          </div>
        )}
        {order && order.orderstatus === "6" && (
          <div>
            <p className="leading-normal">
              It's taking longer than expected to process your order. Please
              check back later.
            </p>
            <p className="leading-normal">
              If the problem persists, please feel free to{" "}
              <Link to="/contact">contact us</Link>
            </p>
          </div>
        )}
        {order && order.orderstatus === "7" && (
          <div>
            <p className="leading-normal mb-6">
              There was a problem processing your order, please try again.
            </p>
          </div>
        )}
        {order && order.orderstatus === "8" && (
          <div>
            <p className="leading-normal">
              Sales for{" "}
              <span className="font-bold text-primary">{event.title}</span>{" "}
              have either ended or are currently unavailable.
            </p>
            <p className="leading-normal">
              Order{" "}
              <span className="font-bold text-primary">#{order.id}</span>{" "}
              has been voided and refunded.
            </p>
            <p className="leading-normal">
              Please <Link to="/contact">contact us</Link> if you have any
              questions or concerns.
            </p>
          </div>
        )}
      </form>
    );
  }
}

export default CheckoutError;
